module.exports = __webpack_public_path__ + "img/Im6.62dce4ef.png";